export const GET_USER = "GET_USER";
export const BLOCK_UNBLOCK_SWITCH = "BLOCK_UNBLOCK_SWITCH";

export const GET_HISTORY = "GET_HISTORY";

export const EDIT_COIN = "EDIT_COIN";

export const ASSIGN_BADGE = "ASSIGN_BADGE";
export const ASSIGN_FRAME = "ASSIGN_FRAME";
export const ASSIGN_TAG = "ASSIGN_TAG";

export const UPDATE_USERNAME = "UPDATE_USERNAME";
export const UPDATE_UNIQUE_ID = "UPDATE_UNIQUE_ID";
export const UPDATE_USER_COUNTRY = "UPDATE_USER_COUNTRY";
export const UPDATE_USD_BALANCE = "UPDATE_USD_BALANCE";
